import { z } from 'zod';

import { SupplierRoleResponseSchema } from './supplier-role.schemas.js';

export const ListSupplierRolesByPartyResponseSchema = z.object({
  items: z.array(SupplierRoleResponseSchema),
});

export type ListSupplierRolesByPartyResponse = z.infer<
  typeof ListSupplierRolesByPartyResponseSchema
>;
